import { Component, EventEmitter, Input, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { IActivityLog } from 'app/models/activity-log.model';
import { MomentPipe } from 'app/pipes/pipes';
import { ApiService } from 'app/services/api.service';

@Component({
    selector: 'app-activity-authentication-details',
    imports: [TranslateModule, RouterModule, MomentPipe],
    templateUrl: './activity-authentication-details.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['../activity-details-dialog/activity-details-content-styles.css']
})
export class ActivityAuthenticationDetailsComponent implements OnChanges {
  @Input() log: IActivityLog;
  @Output() closeDialog = new EventEmitter<void>();

  groups: { GroupId: string; Active: boolean; GroupName?: string }[] = [];

  constructor(private apiService: ApiService) {}

  async ngOnChanges(): Promise<void> {
    const newGroups = (this.log?.details?.alarmStaffGroups || [])
      .filter((g: any) => g.Active);
  
    this.groups = newGroups.map((g: any) => ({
      GroupId: g.GroupId,
      Active: g.Active
    }));
  
    try {
      const allGroups: any = await firstValueFrom(this.apiService.getReceiverTeams());
      this.groups.forEach(g => {
        const match = allGroups.find((ag: any) => ag.groupId === g.GroupId);
        if (match) g.GroupName = match.groupName;
      });
    } catch (err) {
      console.error(err);
    }
  }

  get activeGroups() {
    return this.groups.filter(g => g.Active);
  }
}
